import instance from "./index";
import { extractAnalyzeDisplayMeta } from "../utils/analyzeInsights";

export const uploadFile = async (file) => {
  return await instance.post("/analyze/upload", file);
};

export const runQuery = async ({
  file_name,
  question,
  conversationId,
  modelId,
}) => {
  const payload = {
    file_name: String(file_name ?? ""),
    question,
    conversationId,
    modelId,
  };

  const response = await instance.post("/analyze/runQuery", payload);
  return response.data;
};

export const getInsights = async (messageId) => {
  const response = await instance.get(
    `/analyze/getInsights/${encodeURIComponent(String(messageId ?? ""))}`,
  );
  return extractAnalyzeDisplayMeta(response.data);
};